import { render } from "./posts.vue?vue&type=template&id=2efca684"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"

import "./posts.vue?vue&type=style&index=0&id=2efca684&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__